module.exports = __webpack_public_path__ + "static/img/intro_map.18adbc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/intro_map.jpg
// module id = z88o
// module chunks = 0